import { TicketStatus } from "../enums";

export class TicketHasChangedEventInput {
    public id: number;
    public ticketStatus: TicketStatus;
    public oldTicketStatus: TicketStatus | null;
    public assignedEmployeeId: number | null = null;
    public isClosed: boolean;

    constructor() {
        this.id = 0;
        this.ticketStatus = TicketStatus.Unassigned;
        this.oldTicketStatus = null;
        this.isClosed = false;
    }
}
